<template>
  <v-app id="inspire">
    <div class="work-area-details-wrap">
      <div class="details-header">
        <v-layout wrap class="mt-n4">
            <v-btn class="header-btn-back mb-5" small @click="$router.go(-1)">
                <v-icon class="header-btn-back-icon">navigate_before</v-icon>
                Back
            </v-btn>
        </v-layout>
        <v-layout class="mb-6">
          <v-flex d-flex xs12 md5>
            <div>
                <v-avatar v-if="!no_data.includes(workArea)" size="40" color="primary" class="mr-2" :class="{ pointer: !no_data.includes(workArea.image) }">
                  <img 
                    v-if="!no_data.includes(workArea.image)"
                    :src="workArea.image"
                    @click="
                      vEmit({
                        name: 'openImage',
                        data: workArea.image
                      })
                    " 
                    alt="Work Area Image"
                  />
                  <v-icon v-else size="22px" style="color: #fff;">image</v-icon>
                </v-avatar>
                <v-skeleton-loader
                    v-else-if="loading"
                    class="mr-2"
                    type="avatar"
                ></v-skeleton-loader>
            </div>
            <div>
              <h2 
                v-if="
                  !no_data.includes(workArea) &&
                  !no_data.includes(workArea.type) &&
                  workAreaTypes.some(i => i.slug === workArea.type)
                " class="headline mt-n1">{{ workAreaTypes.find(i => i.slug === workArea.type).name }}</h2>
              <v-skeleton-loader
                  v-else-if="loading"
                  style="width: 350px;"
                  type="heading"
                  class="mb-2"
              ></v-skeleton-loader>
              <div v-if="!no_data.includes(workArea) && (!no_data.includes(workArea.commercial_client_id) || !no_data.includes(workArea.commercial_location_id))" class="body-2">
                <span v-if="!no_data.includes(workArea.commercial_client_id) && clients.some(i => i.commercial_client_id === workArea.commercial_client_id)" class="mr-2"><v-icon size="21px" class="mr-1" style="vertical-align: text-bottom;">corporate_fare</v-icon>{{ clients.find(i => i.commercial_client_id === workArea.commercial_client_id).commercial_customer_name }}</span>
                <span v-if="!no_data.includes(workArea.commercial_location_id) && clients.some(i => i.commercial_location_id === workArea.commercial_location_id)" class="mr-2"><v-icon size="21px" class="mr-1" style="vertical-align: text-bottom;">place</v-icon>{{ clients.find(i => i.commercial_location_id === workArea.commercial_location_id).commercial_location_name }}</span>
              </div>
              <v-skeleton-loader
                  v-else-if="loading"
                  style="width: 150px;"
                  type="text"
              ></v-skeleton-loader>
            </div>
          </v-flex>
        </v-layout>
      </div>
      <v-card class="mt-5">
        <v-layout class="px-4 py-4">
          <h3>Pet Waste Station Details</h3>
        </v-layout>
        <v-divider></v-divider>
        <v-data-table
          :headers="headers"
          :items="!no_data.includes(workArea) ? [workArea] : []"
          :loading="loading"
          loader-height="2"
          class="elevation-0"
          hide-default-header
          hide-default-footer
          mobile-breakpoint="100">
          <template v-slot:item="{item}">
            <tr>
              <td>Work Area Type</td>
              <td>
                  <span v-if="!no_data.includes(item.type) && workAreaTypes.some(i => i.slug === item.type)">{{ workAreaTypes.find(i => i.slug === item.type).name }}</span>
                  <em v-else class="grey--text">No data</em>
              </td>
              <td>Note</td>
              <td>
                  <span v-if="!no_data.includes(item.note)">{{item.note}}</span>
                  <em v-else class="grey--text">No data</em>
              </td>
            </tr>
            <tr>
              <td>Brand</td>
              <td>
                  <span v-if="!no_data.includes(item.brand)">{{ item.brand }}</span>
                  <em v-else class="grey--text">No data</em>
              </td>
              <td>Latitude and longitude</td>
              <td>
                  <span v-if="!no_data.includes(item.geolocation)">{{ formatGeolocation(item.geolocation) }}</span>
                  <em v-else class="grey--text">No data</em>
              </td>
            </tr>
            <tr>
              <td>Model</td>
              <td>
                  <span v-if="!no_data.includes(item.model)">{{ item.model }}</span>
                  <em v-else class="grey--text">No data</em>
              </td>
              <td>Cross Sell/s</td>
              <td>
                  <span v-if="!no_data.includes(item.cross_sells)">{{ item.cross_sells.map(i => i.cross_sell_name).join(', ') }}</span>
                  <em v-else class="grey--text">No data</em>
              </td>
            </tr>
            <tr>
              <td>How full it was on last cleanup</td>
              <td>
                <span 
                  v-if="
                    !no_data.includes(item.last_full_status_value) &&
                    fullStatuses.some(i => i.id === item.last_full_status_value)
                  "
                >{{ fullStatuses.find(i => i.id === item.last_full_status_value).name }}</span>  
                <em v-else class="grey--text">No data</em>
              </td>
              <td></td>
              <td>
                  <!-- <span v-if="!no_data.includes(item.cross_sell)">{{ item.cross_sell }}</span>
                  <em v-else class="grey--text">No data</em> -->
              </td>
            </tr>
            <tr>
              <td>How full it is Average</td>
              <td>
                <span 
                  v-if="
                    !no_data.includes(item.average_full_status_value) &&
                    fullStatuses.some(i => i.id == item.average_full_status_value)
                  "
                >{{ fullStatuses.find(i => i.id == item.average_full_status_value).name }}</span>  
                <em v-else class="grey--text">No data</em>
              </td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td>Commercial Client</td>
              <td>
                <v-layout v-if="!no_data.includes(item.commercial_client_id)" style="margin-left: -14px;">
                  <v-menu bottom right d-inline-flex>
                    <template v-slot:activator="{ on }">
                      <v-btn class="ma-0" v-on="on" icon>
                        <v-icon color="#999">more_vert</v-icon>
                      </v-btn>
                    </template>
                    <v-list class="pa-0">
                      <v-list-item
                        @click="$router.push(`/commercial_client/${item.commercial_client_id}/show`)"
                      >
                        <v-flex class="body-1">
                          <v-icon class="mr-2" color="primary" size="18px">visibility</v-icon>
                          View Client Details
                        </v-flex>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                  <v-layout class="wrap align-center">
                    <v-flex v-if="clients.some(i => i.commercial_client_id === item.commercial_client_id)">
                      {{ clients.find(i => i.commercial_client_id === item.commercial_client_id).commercial_customer_name }}
                    </v-flex>
                    <v-flex v-else>
                      <em class="grey--text">No data</em>
                    </v-flex>
                  </v-layout>
                </v-layout>
                <em v-else class="grey--text">No data</em>
              </td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td>Commercial Location</td>
              <td>
                <v-layout v-if="!no_data.includes(item.commercial_location_id)" style="margin-left: -14px;">
                  <v-menu bottom right d-inline-flex>
                    <template v-slot:activator="{ on }">
                      <v-btn class="ma-0" v-on="on" icon>
                        <v-icon color="#999">more_vert</v-icon>
                      </v-btn>
                    </template>
                    <v-list class="pa-0">
                      <v-list-item
                        @click="$router.push(`/commercial_client/${item.commercial_client_id}/show?commercial_location_id=${item.commercial_location_id}`)"
                      >
                        <v-flex class="body-1">
                          <v-icon class="mr-2" color="primary" size="18px">visibility</v-icon>
                          View Client Details
                        </v-flex>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                  <v-layout class="wrap align-center">
                    <v-flex v-if="clients.some(i => i.commercial_location_id === item.commercial_location_id)">
                      {{ clients.find(i => i.commercial_location_id === item.commercial_location_id).commercial_location_name }}
                    </v-flex>
                    <v-flex v-else>
                      <em class="grey--text">No data</em>
                    </v-flex>
                  </v-layout>
                </v-layout>
                <em v-else class="grey--text">No data</em>
              </td>
              <td></td>
              <td></td>
            </tr>
          </template>
        </v-data-table>
      </v-card>
      <how-full-report></how-full-report>
    </div>
  </v-app>
</template>

<script>
import ApiService from "@/common/api.service"
import { mapActions } from 'vuex'
import HowFullReport from './HowFullReport.vue'

export default {
  name: 'WorkAreaDetails',
  components: {
    HowFullReport
  },
  data () {
    return {
      no_data: [null, "", undefined, "null"],
      loading: false,
      workArea: null,
      clients: [],
      clientsLoading: false,
      workAreaTypes: [
        { name: 'Pet Waste Station', slug: 'pet_station' },
        { name: 'Trash Can', slug: 'trash_can' },
        { name: 'Service Area', slug: 'service_area' },
      ],
      fullStatuses: [],
      headers: [
        { text: '', sortable: false },
        { text: '', sortable: false },
        { text: '', sortable: false },
        { text: '', sortable: false }
      ]
    }
  },
  mounted () {
    this.initialize()
    this.clientAndLocationsList()
  },
  methods: {
    ...mapActions(['vEmit']),
    initialize () {
      this.loading = true
      let body = {
        work_area_id: this.$route.params.id
      }

      ApiService.get("/inventory_tracking/work_area_activity_log/details", body)
        .then(response => {
          this.workArea = response.data.work_area
          this.fullStatuses = response.data.full_statuses
          this.loading = false
          // this.workArea = {
          //   date: '2023-08-03',
          //   image: 'https://sweepandgo-images-staging.s3.us-west-2.amazonaws.com/work_areas/211/331/m5k0ShwdiG9uOxv.jpeg',
          //   type: 'pet_station',
          //   work_brand: 'S&G Premium',
          //   work_model: 'Model 1',
          //   how_full: '1/4',
          //   how_full_average: '1/4',
          //   repair_needed: 'No',
          //   status: 'completed',
          //   commercial_client_name: 'Greg Phillinganes',
          //   commercial_client_id: 211,
          //   commercial_location: 'Phillinganes Park 1',
          //   commercial_location_id: 331,
          //   work_area_id: 254,
          //   geolocation: "[{\"lat\":30.267445685117178,\"lng\":-97.74233874000264}]",
          //   note: 'Test 123',
          // }
        })
        .catch(error => {
          this.loading = false
          console.log(error)
        });
    },
    clientAndLocationsList() {
      this.clientsLoading = true;
      return new Promise((resolve, reject) => {
        ApiService.get("/commercial/location/select", { status: 'active,inactive' })
          .then(response => {
            const clients = response.data.commercial_locations
            let groupedClients = _.groupBy(clients, 'commercial_client_id')
            groupedClients = Object.values(groupedClients).map(client => {
              return [
                ...client,
                {
                  commercial_client_id: client[0].commercial_client_id,
                  commercial_customer_name: client[0].commercial_customer_name,
                  commercial_location_name: 'All Locations',
                }
              ]
            })
            this.clients = groupedClients.flat()
            this.clientsLoading = false;
            resolve()
          })
          .catch(error => {
            console.log(error);
            this.clientsLoading = false
            reject()
          })
      })
    },
    formatGeolocation(str) {
      if (typeof str === 'string') {
        let location = JSON.parse(str)
        if ( 
          Array.isArray(location) &&
          location.length &&
          !this.no_data.includes(location[0].lat) &&
          !this.no_data.includes(location[0].lng)
        ) {
          return `lat: ${location[0].lat}; lng: ${location[0].lng}`
        }
      }
      return str
    }
  }
}
</script>